// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"701826ec","453":"d30a19be","455":"eaf92429","977":"871c0204"}[chunkId] + ".chunk.js";
};